






















































































import _ from 'lodash'
import {
    Vue,
    Component,
    Inject,
    Ref
} from 'vue-property-decorator'

import type {
    ElForm,
} from 'element-ui/types/form'


import Form from 'element-ui/lib/form';
import FormItem from 'element-ui/lib/form-item';
import Input from 'element-ui/lib/input';
import Loading from 'element-ui/lib/loading';
import Autocomplete from 'element-ui/lib/autocomplete';
import PtDialog from '@patsnap-biz/dialog'
import MessageBox from 'element-ui/lib/message-box';
import {withLoading} from '../../utils/task'
import {
    E_CaseTimeAction,
    E_CaseTimeStatus,
    ICompanyCaseBaseItem,
    IUserCaseItem,
    E_Buttons
} from '../../service/caseTime.types'
import {
    asyncValidateMaxLength
} from '../../utils/validators'
import {CASE_TIME_CONTEXT} from '../../constatnts'
import {Context} from '../../context'
import {renameDirective} from '../../utils/hack_vue'
import {mayHandleError} from '../../errorHandler'
import {i18nOption} from '../../i18n/i18n'
import CaseTimeButton from './CaseTimeButton.vue'
import CaseTimeClock from "./CaseTimeClock.vue";
import PtIcon from '@patsnap-biz/icon'
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg'


function makeForm(userCaseItem?: IUserCaseItem) {
    if (!userCaseItem) {
        return {
            title: '',
            description: '',
        }
    }
    const {
        title,
        description,
        status,
        action,
    } = userCaseItem
    if (status === E_CaseTimeStatus.DONE && action !== E_CaseTimeAction.PAUSE) {
        return {
            title: '',
            description: '',
        }
    }
    return {
        title: title || '',
        description: description || ''
    }
}

// 需要hack下vue,
// loading被element-ui覆盖后显示有问题
renameDirective(Vue, () => {
    Vue.use(Loading)
}, 'loading', 'base-loading')


@Component({
    name: 'CaseTimeDialog',
    components: {
        PtIcon,
        PtDialog,
        CaseTimeButton,
        CaseTimeClock,
        'base-form': Form,
        'base-form-item': FormItem,
        'base-input': Input,
        'base-autocomplete': Autocomplete,
    },
    i18n: i18nOption,
})
class CaseTimeDialogImpl extends Vue {
    @Inject(CASE_TIME_CONTEXT)
    context!: Context


    E_Buttons = E_Buttons
    E_CaseTimeStatus = E_CaseTimeStatus

    loading = false
    allCompanyCaseBase: ICompanyCaseBaseItem[] = []

    get LabelWidth() {
        // 日文偏长
        if (this.$i18n.locale === 'jp') {
            return '138px'
        } else {
            return '117px'
        }
    }

    get userCaseItem() {
        return this.context.Service.currentUserCaseViewData;
    }

    get Status() {
        return this.userCaseItem?.status || E_CaseTimeStatus.DONE
    }

    get InPausing() {
        if (!this.userCaseItem) {
            return false
        }
        return this.userCaseItem?.action === E_CaseTimeAction.PAUSE
    }

    get Action() {
        if (!this.userCaseItem) {
            return null
        }
        return this.userCaseItem.action
    }

    showDialog = false

    showCloseConfirmDialog = false

    @Ref()
    formRef: ElForm

    form = makeForm()

    get Rules() {
        const titleErrorMsg = this.$t('case_time.overflow_title_error') as string
        return {
            title: [{
                required: true, message: titleErrorMsg, trigger: 'change', transform: (value) => _.trim(value)
            }, {
                validator: asyncValidateMaxLength({
                    maxLength: 40,
                    errorMsg: titleErrorMsg
                }), trigger: 'change',
            }],
            description: [{
                validator: asyncValidateMaxLength({
                    maxLength: 2048,
                    errorMsg: this.$t('case_time.overflow_description_error') as string
                }), trigger: 'blur',
            }]
        }
    }

    get ButtonsEnabled() {
        const title = _.trim(this.form.title)
        const titleLength = _.size(title)
        const validatedTitle = 0 < titleLength && titleLength <= 40
        const DISABLED_END_ACTIONS = [
            E_CaseTimeAction.END,
            // E_CaseTimeAction.START,
            // 开始状态下也不能直接结束,
            null,
            undefined,
        ]
        return {
            [E_Buttons.Start]: validatedTitle,
            [E_Buttons.Pause]: true,
            [E_Buttons.Restart]: true,
            [E_Buttons.End]: validatedTitle && !(DISABLED_END_ACTIONS.includes(this.Action)),
        }
    }

    get ButtonsShow() {
        return {
            [E_Buttons.Start]: this.Status == E_CaseTimeStatus.DONE && !this.InPausing,
            [E_Buttons.Pause]: this.Status == E_CaseTimeStatus.WORKING,
            [E_Buttons.Restart]: this.Status == E_CaseTimeStatus.DONE && this.InPausing,
        }
    }

    get FormEnabeld() {
        return this.Status === E_CaseTimeStatus.DONE && !this.InPausing
    }



    onSelectProject(caseBase:ICompanyCaseBaseItem) {
        if(caseBase) {
            this.form.description = caseBase.description || ''
        }
    }

    private _lastAppliedTitle?: string = undefined // 避免反复重填
    onTitleInputBlur() {
        const matchedCase = this.allCompanyCaseBase.find(item => item.title === this.form.title)
        if(matchedCase && this._lastAppliedTitle !== matchedCase.title) {
            this.form.description = matchedCase.description || ''
            this._lastAppliedTitle = matchedCase.title;
        } else {
            this._lastAppliedTitle = undefined
        }
    }

    queryCaseTimeTitles(query: string, cb) {
        let res = _.filter(this.allCompanyCaseBase, caseBase => {
            const title = caseBase.title
            return title.toLowerCase().indexOf(query.toLowerCase()) > -1
        })
        // 项目弹框-项目名-下拉框：点击输入框，下拉框默认展示该公司项目下的Top5, 否则Top10
        const sliceNum = query ? 10 : 5
        res = res.slice(0, sliceNum)
        return cb(_.map(res, caseBase => {
            return {
                ...caseBase,
                value: caseBase.title,
            }
        }))
    }

    async onUpdateCaseTime(action: E_CaseTimeAction) {
        const validated = await this.formRef.validate();
        if (validated) {
            const {
                title,
                description,
            } = this.form
            this.$emit('update', {
                action,
                form: {
                    title: _.trim(title),
                    description: _.trim(description),
                }
            })
        }
    }

    onClickStart() {
        return this.onUpdateCaseTime(E_CaseTimeAction.START)
    }

    onClickPause() {
        return this.onUpdateCaseTime(E_CaseTimeAction.PAUSE)
    }

    onClickRestart() {
        return this.onUpdateCaseTime(E_CaseTimeAction.RESTART)
    }

    onClickEnd() {
        return this.onUpdateCaseTime(E_CaseTimeAction.END)
    }

    tempShowMsg: string = '';
    tempShowMsgType:'warning'|'error' = 'warning'

    async Show(params?: { warnMsg: string, msgType: 'warning'|'error' }) {

        this.tempShowMsg = params?.warnMsg || ''
        this.tempShowMsgType = params?.msgType || 'warning'


        if (!this.tempShowMsg && !this.context.Service.isWorking) {
            this.tempShowMsg = this.$t('case_time.starTip') as string;
        }

        this.showDialog = true
        try {
            if (this.formRef) {
                this.formRef.clearValidate()
            }
        } catch (e) {
            console.error('CaseTime Warning: current page still using element-ui 1.0!')
        }

        // 每次获取最新的 caseView
        await withLoading(this, this.context.Service.updateCurrentUserCaseView())
        this.form = makeForm(this.userCaseItem)
        // todo 每次前端取出所有的 title??
        const task = this.context.Service.caseTime.getAllCompanyCaseBase()
        try {
            const {data} = await withLoading(this, task)
            this.allCompanyCaseBase = data
        } catch (e) {
            mayHandleError(this, e)
        }
    }

    closeAlert() {
        if(this.loading) {
            return Promise.reject()
        }
        if(this.Status === E_CaseTimeStatus.WORKING) {
            return Promise.resolve()
        }
        return MessageBox.confirm('', this.$t('case_time.beforeCloseTip'), {
            customClass: 'case-time-dialog__before-close',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            confirmButtonText: this.$t('case_time.confirm'),
            cancelButtonText: this.$t('case_time.cancel'),
            confirmButtonClass: 'case-time-dialog__confirm-btn',
            cancelButtonClass: 'case-time-dialog__cancel-btn',
            type: 'warning'
        })
    }

    Hidden() {
        this.closeAlert().then(() => {
            this.showDialog = false
            this.tempShowMsg = ''
        })
    }

    beforeClose(done) {
        this.closeAlert().then(() => done())
    }

    ClearForm() {
        this.form = makeForm()
        this.$nextTick(() => this.formRef.clearValidate())
    }
}

export default CaseTimeDialogImpl
